"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RiskLevel = exports.Criticality = exports.Jurisdiction = exports.ComplianceFramework = exports.AssetType = void 0;
// Enums
var AssetType;
(function (AssetType) {
    AssetType["CLOUD"] = "CLOUD";
    AssetType["SAAS"] = "SAAS";
    AssetType["API"] = "API";
    AssetType["AI"] = "AI";
    AssetType["SOFTWARE"] = "SOFTWARE";
})(AssetType || (exports.AssetType = AssetType = {}));
var ComplianceFramework;
(function (ComplianceFramework) {
    ComplianceFramework["GDPR"] = "GDPR";
    ComplianceFramework["NIS2"] = "NIS2";
    ComplianceFramework["DORA"] = "DORA";
    ComplianceFramework["EPRIVACY"] = "EPRIVACY";
    ComplianceFramework["AI_ACT"] = "AI_ACT";
    ComplianceFramework["ISO27001"] = "ISO27001";
    ComplianceFramework["SOC2"] = "SOC2";
    ComplianceFramework["HIPAA"] = "HIPAA";
    ComplianceFramework["PCI_DSS"] = "PCI_DSS";
})(ComplianceFramework || (exports.ComplianceFramework = ComplianceFramework = {}));
var Jurisdiction;
(function (Jurisdiction) {
    Jurisdiction["EU"] = "EU";
    Jurisdiction["US"] = "US";
    Jurisdiction["UK"] = "UK";
    Jurisdiction["CHINA"] = "CHINA";
    Jurisdiction["INDIA"] = "INDIA";
    Jurisdiction["HONG_KONG"] = "HONG_KONG";
    Jurisdiction["RUSSIA"] = "RUSSIA";
    Jurisdiction["SWITZERLAND"] = "SWITZERLAND";
    Jurisdiction["BRAZIL"] = "BRAZIL";
    Jurisdiction["SINGAPORE"] = "SINGAPORE";
    Jurisdiction["AUSTRALIA"] = "AUSTRALIA";
    Jurisdiction["CANADA"] = "CANADA";
    Jurisdiction["JAPAN"] = "JAPAN";
    Jurisdiction["OTHER"] = "OTHER";
})(Jurisdiction || (exports.Jurisdiction = Jurisdiction = {}));
var Criticality;
(function (Criticality) {
    Criticality["LOW"] = "LOW";
    Criticality["MEDIUM"] = "MEDIUM";
    Criticality["HIGH"] = "HIGH";
})(Criticality || (exports.Criticality = Criticality = {}));
var RiskLevel;
(function (RiskLevel) {
    RiskLevel["LOW"] = "LOW";
    RiskLevel["MEDIUM"] = "MEDIUM";
    RiskLevel["HIGH"] = "HIGH";
})(RiskLevel || (exports.RiskLevel = RiskLevel = {}));
